import React from 'react';
import Card, {cardType} from './common/components/Card';
import {updateField} from './Content';
import '../assests/css/cardview.scss';

export interface cardViewProps {
    data: cardType[],
    handleUpdate: (reqBody: any, field: updateField,
        endpoint?: string)=> Promise<number | void>,
    onWholesalersSelect: (select: boolean)=> void,
    onGroupIdSelected: (id: number)=> void,
    groupIdSelected: number,
}

export default function CardView(props: cardViewProps) {

    const {data, handleUpdate, onWholesalersSelect,
        onGroupIdSelected, groupIdSelected} = props;

    return (
        <div className="cardview-container">
            {data.map((eachCard, index)=> {
                return  <Card key={`cardview-item-${index}`}
                    data = {{...eachCard,
                        showPopup: groupIdSelected!==0 &&
                        eachCard.groupId === groupIdSelected?
                        true: false}}
                    handleUpdate={(reqBody: any, field: updateField,
                        endpoint?: string)=>
                            handleUpdate(reqBody, field, endpoint)}
                        onWholesalersSelect={(selected) =>
                            onWholesalersSelect(selected)}
                        onGroupIdSelected = {(id) =>
                            onGroupIdSelected(id)}
                        />
            })}
        </div>
    );

}